
import React, { Component } from 'react';
import './style.css';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
//import cover from 'Assets/cover.png'
import Button from '../Button/Button';
import nightLogo from 'Assets/night-logo.svg'
import { withRouter } from 'react-router-dom';
import { user_Status} from "Api/Api";
import { origin } from 'utils/Helper';


class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  CreatePk=()=>{
    if (user_Status === 1) {
      localStorage.clear();
      window.location.href = window.location.protocol+'//'+window.location.hostname+'/';
    } else {
      window.location.href = origin; 
    }  }

    // GetLogin = () => {
    //   this.props.history.push("/login");
    //   window.location.href = `${origin}/login`;
    // }

    PKCreation = () => {
      this.props.history.push("/pkcreation");
    }
  
  render() { 
    return (
      <div>
      {/* Banner section starts */}
      {
          (this.props.pageStatus === "HomePage") ?
          <Row style={{ marginLeft: 0, marginRight: 0 }}>
          <section className="HomePage-head">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className="HomePage-logo">
                  <h5>Don't be shy, create your first PK!</h5>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                  <Button theme="btn-global btn-hover btn-green HomePage-btn" OnClickMet={this.PKCreation}>Create a pk</Button>
                  </div>
                   </div>
              </div>
            </div>
          </section>
        </Row>
        :(this.props.pageStatus === "Eventspage") ?
          <Row style={{ marginRight: 0, marginLeft: 0 }}>
            <section className="events-head">
              <div className="container">
                <div className="row">
                  <Col sm={12} md={12} lg={8}>
                    <h1>{this.props.locationsText !== undefined ? this.props.locationsText : ''} <span>Vol {this.props.vol !== undefined && this.props.vol !== null ? this.props.vol : ''}</span></h1>
                    <div className="event-cover">
                      {this.props.poster_image !== undefined ?
                        <img src={this.props.poster_image} alt="img" className="img-fluid" />
                        :
                        null
                      }
                      <p dangerouslySetInnerHTML={{__html:this.props.title !== undefined ? this.props.title : ''}}/>
                      <p> {this.props.content !== undefined ? this.props.content : ''} </p>
                      <p> {this.props.author !== undefined ? this.props.author : ''}</p>
                      {/* <Button theme="btn-global btn-hover btn-green">Buy Tickets</Button> */}
                    </div>
                  </Col>
                </div>
              </div>
            </section>
          </Row>
          :(this.props.pageStatus === "GuestHome") ?
          <Row style={{ marginRight: 0, marginLeft: 0 }}>
            <section className="guesthome-head">
              <div className="container">
                <div className="row">
                  <Col sm={12} md={12} lg={8}>
                    <div className="guest-btn">
                    <h1>{this.props.creators}</h1>
                    <div className="guesthome-content">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    </div>
                    {/* <div> */}
                    <a href="/login">
                    <Button theme="btn-global btn-hover btn-green btn-fit">Get Started</Button>
                    </a>
                    {/* </div> */}
                    </div>
                  </Col>
                </div>
              </div>
            </section>
          </Row>
           :
          <Row style={{ marginLeft: 0, marginRight: 0 }}>
            <section className="city-head">
              <div className="container">
                <div className="row">
                  <div className="col-sm-7">
                    <div className="city-logo">
                      <img src={nightLogo} alt="img" className="img-fluid" />
                    </div>
                    <h1>{this.props.locationCity}</h1>
                  </div>
                </div>
              </div>
            </section>
          </Row>
          
      }
    </div>
      // {/* Banner section Ends */}
    );
  }
}


export default withRouter (Banner);
